export default "__VITE_ASSET__d130dd9a__"